import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { HarlequinBusinessCardStackContentViewModel } from './harlequin-business-card-stack-content-view-model';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';

@Component({
  selector: 'app-harlequin-business-card-stack-content',
  templateUrl: './harlequin-business-card-stack-content.component.html',
  styleUrls: ['./harlequin-business-card-stack-content.component.scss'],
  providers: [HarlequinBusinessCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HarlequinBusinessCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public viewModel: HarlequinBusinessCardStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
